import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PublicChrome from './public/PublicChrome';
import { getFullImageUrl, handleImageError } from '../utils/imageUtils';

interface Project {
  _id: string;
  title: string;
  slug: string;
  description: string;
  imageUrl: string;
  category: string;
  network: string;
  tags: string[];
  featured: boolean;
}

interface LayoutProps {
  children: React.ReactNode;
  showServicesModal?: boolean;
  setShowServicesModal?: (show: boolean) => void;
  currentPage?: 'home' | 'stake' | 'services' | 'blog' | 'labs' | 'about' | 'other';
  projects?: Project[];
  headerVariant?: 'main' | 'project';
}

const Layout: React.FC<LayoutProps> = ({
  children,
  showServicesModal = false,
  setShowServicesModal = () => {},
  projects = [],
}) => {
  useEffect(() => {
    if (showServicesModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showServicesModal]);

  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 767 : false
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <PublicChrome>
      <div className="dusk-public-content">{children}</div>

      {showServicesModal && (
        <div
          className="fixed inset-0 z-[99999] bg-dusk-ink/60 flex items-start justify-center p-4 overflow-y-auto"
          onClick={() => setShowServicesModal(false)}
          role="presentation"
        >
          <div
            className="bg-dusk-paper border border-[var(--dusk-line)] w-full max-w-3xl my-10 p-6"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
          >
            <div className="flex justify-between items-center mb-6">
              <h2 className="font-display text-2xl text-dusk-ink m-0">Services</h2>
              <button
                type="button"
                className="text-2xl text-dusk-muted bg-transparent border-0 cursor-pointer"
                onClick={() => setShowServicesModal(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>
            <div className={`grid gap-3 ${isMobile ? 'grid-cols-1' : 'grid-cols-2'}`}>
              {projects
                .filter((p) => p.category === 'Services')
                .map((pr) => (
                  <Link
                    key={pr._id}
                    to={`/services/${pr.network}/${pr.slug}`}
                    className="flex items-center gap-3 p-3 no-underline border border-[var(--dusk-line)] hover:border-dusk-copper transition-colors"
                    onClick={() => setShowServicesModal(false)}
                  >
                    <img
                      src={getFullImageUrl(pr.imageUrl) || '/images/default-project.png'}
                      alt=""
                      className="h-8 w-8 object-contain"
                      onError={handleImageError}
                    />
                    <span className="text-sm text-dusk-ink font-medium">{pr.title}</span>
                  </Link>
                ))}
            </div>
          </div>
        </div>
      )}
    </PublicChrome>
  );
};

export default Layout;
